// Talks to the FlyAfriTrip backend's public find-my-booking endpoint
// (see ~/Desktop/flyafritrip-middleware/docs/flighthub-post-booking.md).
// No API key here on purpose — this is the one endpoint the browser is
// allowed to call directly; it identifies the caller by reference + last
// name instead, checked against FlightHub's own live data server-side.
import { tr } from './i18n';
const API_BASE = process.env.REACT_APP_API_BASE || 'https://api.flyafritrip.com';

export class BookingNotFoundError extends Error {}
export class BookingLookupError extends Error {}

/**
 * @param {string} reference booking reference or FAT-xxxx / PNR
 * @param {string} lastName
 * @returns {Promise<{tripDetails: object, transactionSummary: object|null, fareRules: object|null}>}
 */
export async function findBooking(reference, lastName) {
  let res;
  try {
    res = await fetch(`${API_BASE}/v1/bookings/find`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ reference, last_name: lastName })
    });
  } catch {
    throw new BookingLookupError(tr('apiUnreachable'));
  }

  if (res.status === 404) {
    throw new BookingNotFoundError(tr('apiNotFound'));
  }
  if (res.status === 429) {
    throw new BookingLookupError(tr('apiRate'));
  }
  if (!res.ok) {
    throw new BookingLookupError(tr('apiFailed'));
  }

  const body = await res.json();
  return {
    tripDetails: body.trip_details?.data ?? null,
    transactionSummary: body.transaction_summary?.data ?? null,
    fareRules: body.fare_rules?.data ?? null
  };
}
